import { render, staticRenderFns } from "./SendCallToAllDialog.vue?vue&type=template&id=70990d4f&scoped=true&"
import script from "./SendCallToAllDialog.vue?vue&type=script&lang=js&"
export * from "./SendCallToAllDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendCallToAllDialog.vue?vue&type=style&index=0&id=70990d4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70990d4f",
  null
  
)

export default component.exports